import { useState } from 'react'
import styled from 'styled-components'

import ActionIcon from 'components/lib/DesignSystem/ActionIcon'
import Checkbox from 'components/lib/DesignSystem/Checkbox'
import { Info } from 'components/lib/DesignSystem/Icons'
import Input from 'components/lib/DesignSystem/Input'
import Tooltip from 'components/lib/DesignSystem/Tooltip'
import { onMobile } from 'components/styles/utils/breakpoints'

const FirstPasswordForm = ({
  className,
  password = '',
  newPassword = '',
  repeatNewPassword = '',
  onChange,
  validator,
  enforcePasswords = false,
  twoFactorAuth = false,
  error,
}) => {
  const [touched, setTouched] = useState({
    password: false,
    newPassword: false,
    repeatNewPassword: false,
  })

  const changeTouched = (name) => {
    setTouched((prevTouched) => ({
      ...prevTouched,
      [name]: true,
    }))
  }

  const changeField = (event) => {
    const { name, value } = event.currentTarget
    changeTouched(name)
    onChange(name, value)
  }

  const changeCheckbox = (event) => {
    const { name, checked } = event.target
    onChange(name, checked)
  }

  return (
    <div className={className}>
      <div className="form">
        <Input
          id="First_Login_Form_Password"
          value={password}
          name="password"
          type="password"
          onChange={changeField}
          onFocus={(e) => changeTouched(e.currentTarget.name)}
          labelText="*Current password"
          meta={{
            error: validator.password,
            touched: touched.password,
          }}
        />

        <Input
          type="password"
          id="First_Login_Form_New_Password"
          value={newPassword}
          name="newPassword"
          onChange={changeField}
          labelText="*New password"
          meta={{
            error: validator.newPassword,
            touched: touched.newPassword,
          }}
          onFocus={(e) => changeTouched(e.currentTarget.name)}
        />

        <Input
          type="password"
          id="First_Login_Form_Match_Password"
          value={repeatNewPassword}
          name="repeatNewPassword"
          onChange={changeField}
          labelText="*Confirm new password"
          meta={{
            error: validator.repeatNewPassword,
            touched: touched.repeatNewPassword,
          }}
          onFocus={(e) => changeTouched(e.currentTarget.name)}
        />
      </div>
      {error ? (
        <div id="First_Login_Form_Error" className="error">
          {error.detail}
        </div>
      ) : null}
      <div className="checkbox_container">
        <Checkbox
          onChange={changeCheckbox}
          name="twoFactorAuth"
          checked={twoFactorAuth}
          label="Enable Two Factor Authentication"
          id="First_Login_Form_Two_Factor_Auth_Checkbox"
        />
        <div className="checkbox_container_with_tooltip">
          <Checkbox
            onChange={changeCheckbox}
            name="enforcePasswords"
            checked={enforcePasswords}
            label="Enforce Password Policies"
            id="First_Login_Form_Enforce_Passwords_Checkbox"
          />
          <Tooltip
            placement="right"
            overlayStyle={{
              maxWidth: '250px',
              whiteSpace: 'normal',
            }}
            text={
              <span style={{ fontSize: '12px' }}>
                Enabling Password Policies expires the password every 90 days and enforces password
                restrictions.{' '}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  id="Enforce_Passwords_Read_more"
                  href="https://support.ironscales.com/hc/en-us/articles/360016886640-Password-Policies"
                >
                  Read more
                </a>
                .
              </span>
            }
          >
            <ActionIcon Icon={Info} className="sml" iconProps={{ width: '15px', height: '15px' }} />
          </Tooltip>
        </div>
      </div>
    </div>
  )
}

export default styled(FirstPasswordForm)`
  display: flex;
  flex-direction: column;
  .field-error {
    position: static;
    white-space: pre-wrap;
  }
  ${onMobile()} {
    align-items: center;
  }

  .form {
    width: 260px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .checkbox_container {
    margin-top: 22px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    &_with_tooltip {
      display: flex;
      align-items: center;
    }
  }

  .error {
    color: var(--red);
    font-weight: 600;
    font-size: 12px;
  }
`
